import { CSSProperties } from 'styled-components';

export type MarginProps = {
  margin?: CSSProperties['margin'];
  m?: CSSProperties['margin'];
  marginTop?: CSSProperties['marginTop'];
  mt?: CSSProperties['marginTop'];
  marginRight?: CSSProperties['marginRight'];
  mr?: CSSProperties['marginRight'];
  marginBottom?: CSSProperties['marginBottom'];
  mb?: CSSProperties['marginBottom'];
  marginLeft?: CSSProperties['marginLeft'];
  ml?: CSSProperties['marginLeft'];
  mx?: CSSProperties['margin'];
  my?: CSSProperties['margin'];
};

const MARGIN_PROPS: ReadonlyArray<keyof MarginProps> = [
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
];

export const margin = (props: MarginProps) => ({
  margin: props.margin || props.m,
  marginTop: props.marginTop || props.mt,
  marginRight: props.marginRight || props.mr,
  marginBottom: props.marginBottom || props.mb,
  marginLeft: props.marginLeft || props.ml,
  ...(props.mx
    ? {
        marginRight: props.mx,
        marginLeft: props.mx,
      }
    : {}),
  ...(props.my
    ? {
        marginTop: props.my,
        marginBottom: props.my,
      }
    : {}),
});

const isMarginProps = (key: any): key is typeof MARGIN_PROPS[number] =>
  MARGIN_PROPS.includes(key as any);

export const extractMarginProps = <P extends { [P: string]: any }>(props: P) =>
  Object.keys(props).reduce<MarginProps>((_props, propName) => {
    if (isMarginProps(propName)) {
      return {
        ..._props,
        [propName]: props[propName],
      };
    }
    return _props;
  }, {});
